import { useState } from 'react'
import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useUploadFileMutation, useUploadFileRequestMutation } from '../../store/media/file'
import { useUpdateFileMutation } from '../../store/media/media'
import { FileKind, FileStatus } from '../../models/File'

type UploadResult = { attachmentFileId?: string } | null

export function useConsentFileUpload() {
  const accountId = useAppSelector(selectAccountId)
  const [file, setFile] = useState<File | null>(null)

  const [uploadFileRequest, { isLoading: isRequestingUpload }] = useUploadFileRequestMutation()
  const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation()
  const [updateFile, { isLoading: isUpdating }] = useUpdateFileMutation()

  const isUploadingFile = isRequestingUpload || isUploading || isUpdating

  const uploadFileIfPresent = async (): Promise<UploadResult> => {
    if (!file) {
      return {}
    }

    try {
      const {
        data: {
          fileUploadUrl,
          fileUploadParameters,
          fileInfo: { fileId },
        },
      } = await uploadFileRequest({
        accountId,
        body: {
          fileName: file.name,
          fileSize: file.size,
          contentType: file.type,
          kind: FileKind.COMPLIANCE_ASSET,
        },
      }).unwrap()
      await uploadFile({ uploadUrl: fileUploadUrl, uploadParameters: fileUploadParameters, file }).unwrap()
      await updateFile({ accountId, fileId, body: { status: FileStatus.UPLOADED } }).unwrap()
      return { attachmentFileId: fileId }
    } catch {
      return null
    }
  }

  return { file, setFile, isUploadingFile, uploadFileIfPresent }
}
